/*
 * Copyright (c) 2022 E-WIND - Thais Watanabe.
 * All rights reserved.
 */
import React from "react";

import isInputCorrect from "src/utils/ResultValidationHelper";

import Card from "src/components/cards/Card.react";
import ResultDropdown from "src/components/dropdowns/Result.react";

import {
  Table,
  ColHeader,
  TableBody,
  Col,
} from "src/components/tables/Table.react";
import ResultBadge from "src/components/badges/Result.react";
import PrintHeader from "src/components/print/PrintHeader.react";

/**
 * The Result component
 *
 * @author Thais Watanabe
 */
const TowerBase = (props) => {
  const {
    turbineInspection,
    inspectionModel,
    inspectionModelItems,
    results,
    openEdit,
    openObs,
    inspection,
    lastTurbineInspections,
  } = props;

  const i2_4 = inspectionModelItems.filter((obj) => obj.name === "2-4")?.[0];
  const r2_4 = results.filter((obj) => obj.itemId === "2-4")?.[0];

  const i2_7 = inspectionModelItems.filter((obj) => obj.name === "2-7")?.[0];
  const r2_7 = results.filter((obj) => obj.itemId === "2-7")?.[0];

  return (
    <Card className="pagebreak">
      <PrintHeader
        inspectionModel={inspectionModel}
        inspection={inspection}
        turbineInspection={turbineInspection}
      />

      <Table>
        <thead>
          <tr>
            <ColHeader colSpan={4}>各種データ表示確認一覧に記載</ColHeader>
          </tr>
          <tr>
            <ColHeader>No</ColHeader>
            <ColHeader>項目</ColHeader>
            <ColHeader id="2-4">
              <ResultDropdown
                turbineInspection={turbineInspection}
                openEdit={openEdit}
                openObs={openObs}
                selectedItem={i2_4}
                selectedResult={r2_4}
                lastTurbineInspections={lastTurbineInspections}
                inspection={inspection}
              />
              現地確認
            </ColHeader>
            <ColHeader id="2-7">
              <ResultDropdown
                turbineInspection={turbineInspection}
                openEdit={openEdit}
                openObs={openObs}
                selectedItem={i2_7}
                selectedResult={r2_7}
                lastTurbineInspections={lastTurbineInspections}
                inspection={inspection}
              />
              遠隔確認
            </ColHeader>
          </tr>
        </thead>
        <TableBody>
          {i2_7?.inspectionModelItemChildren.items
            .sort((a, b) => (a.itemChildNumber > b.itemChildNumber ? 1 : -1))
            .map((itemChild, x) => (
              <tr key={"x" + x}>
                <Col>{itemChild.itemChildNumber}</Col>
                <Col>{itemChild.name}</Col>
                <Col className="text-center">
                  <ResultBadge
                    result={
                      x < 7
                        ? r2_4?.childrenResults?.[x]
                        : x > 20
                        ? r2_4?.childrenResults?.[x - 14]
                        : "-"
                    }
                    unit={itemChild.unit}
                    isInputCorrect={isInputCorrect(
                      "2-4",
                      x < 7
                        ? r2_4?.childrenResults?.[x]
                        : x > 20
                        ? r2_4?.childrenResults?.[x - 14]
                        : "-",
                      x
                    )}
                  />
                </Col>
                <Col className="text-center">
                  <ResultBadge
                    result={r2_7 ? r2_7.childrenResults?.[x] : "-"}
                    unit={itemChild.unit}
                    isInputCorrect={isInputCorrect(
                      "2-7",
                      r2_7 ? r2_7.childrenResults?.[x] : "-",
                      x
                    )}
                  />
                </Col>
              </tr>
            ))}
        </TableBody>
      </Table>
    </Card>
  );
};

export default TowerBase;
